import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ReviewerDTO, ReviewerEntity } from '../models/reviewer.model';

@Injectable({ providedIn: 'root' })
export class ReviewerService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/api/v1/projects`;

  private reviewersUrl(projectId: string, entity: ReviewerEntity, entityId: string): string {
    return `${this.baseUrl}/${projectId}/${entity}/${entityId}/reviewers`;
  }

  list(projectId: string, entity: ReviewerEntity, entityId: string): Observable<ReviewerDTO[]> {
    return this.http.get<ReviewerDTO[]>(this.reviewersUrl(projectId, entity, entityId));
  }

  add(projectId: string, entity: ReviewerEntity, entityId: string, reviewerUserId: string): Observable<ReviewerDTO[]> {
    return this.http.post<ReviewerDTO[]>(this.reviewersUrl(projectId, entity, entityId), { reviewerUserId });
  }

  remove(projectId: string, entity: ReviewerEntity, entityId: string, reviewerUserId: string): Observable<void> {
    return this.http.delete<void>(`${this.reviewersUrl(projectId, entity, entityId)}/${reviewerUserId}`);
  }
}
